var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 1.06066L4.05546 5.11612C5.1294 6.19006 6.8706 6.19006 7.94454 5.11612L12 1.06066V7C12 7.55228 11.5523 8 11 8H1C0.447715 8 0 7.55228 0 7V1.06066ZM1.06066 0H10.9393L6.88388 4.05546C6.39573 4.54361 5.60427 4.54361 5.11612 4.05546L1.06066 0Z","fill":"#F7F8FA"}));
}

Mail.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
